<template>
    <div class="publication__filters content-width">

        <div class="d-flex">

            <div class="publication__section-inner d-flex">
                <div class="publication__section-item">
                    <div class="publication__section-title">Вес питомца</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in filtersServer.weight">
                            <label class="d-flex">
                                <input type="radio" v-model="weight" :value="key">
                                <span class="circle"></span>
                                {{value}}
                            </label>
                        </div>
                    </div>


                </div>
            </div>

        </div>

        <div class="publication__filters-row">

            <div class="publication__filters-title">
                Дополнительнительные фильтры
            </div>

            <div class="publication__filters-grid d-flex">
                <label class="publication__filters-item" v-for="filter in filtersServer.pet_filter_id" :key="filter.id">

                    <div class="publication__filters-item-inner d-flex" :class="{'publication__filters-item-inner--selected': filters.indexOf(filter.id) >= 0 }">
                        <div class="publication__filters-item-heading">
                            <div class="publication__filters-item-icon d-flex" :style="{background: filter.color}" >
                                <img :src="`/assets/images/${filter.icon}`" alt="">
                            </div>
                            <div class="publication__filters-item-name">
                                {{filter.name}}
                            </div>
                            <div class="publication__filters-item-description">
                                {{filtersDescription[ filter.name_en ]}}
                            </div>
                        </div>

                        <div class="publication__filters-item-body">
                            <div class="publication__filters-item-checkbox">
                                <input type="checkbox" :value="filter.id" v-model="filters">
                            </div>
                        </div>

                    </div>

                </label>
            </div>

            <div class="text-danger" v-show="!$v.filters.maxLength" >Не больше 4 фильтров.</div>

        </div>
        <div class="publication__filters-row">

            <div class="publication__filters-title">
                Социальные артибуты
            </div>

            <div class="publication__social d-flex">

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'to_children', value: to_children}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(to_children)" >{{`${to_children}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        Отношение к детям
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'to_cats', value: to_cats}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(to_cats)" >{{`${to_cats}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        Отношение к котам
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'to_dogs', value: to_dogs}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(to_dogs)" >{{`${to_dogs}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        Отношение к собакам
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'enrichment', value: enrichment}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(enrichment)" >{{`${enrichment}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        Условия жизни
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'human_sociability', value: human_sociability}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(human_sociability)" >{{`${human_sociability}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        Социальность
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>



const filtersDescription = {
    'Old': 'Животное старше 10 лет',
    'Disabled': 'Не может выполнять привычные функции',
    'Seeking for home': 'Животное ищет дом',
    'Sos situations': 'Критическая ситуация',
    'Donor': 'Животному требуется донор крови',
    'Homestay': 'Животное ищет передежрку',
    'PR': 'Помощь в рассылке информации',
    'Supervisor': 'Животное ищет другого куратора',
    'Auto aid': 'Требуется помощь с перевозкой',
    'Captured': 'Животное которое находилось в отлове',
    'Photo aid': 'Животному требуется помощь фотографа',
};

import { required, maxLength, requiredIf} from 'vuelidate/lib/validators';

import Star from '../PublicationSocialStar';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PetFilters",
    props: ['server'],
    components: { Star },
    mixins: [StateMixin],
    computed: {

        filtersServer(){ return this.server.dictionaries },
        filtersDescription() { return filtersDescription },

        filters: {
            get() { return this.GET_BY_KEY('filters') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'filters', data: val})
            }
        },

        weight: {
            get() { return this.GET_BY_KEY('weight') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'weight', data: val})
            }
        },

        to_children: {
            get() { return this.GET_BY_KEY('to_children') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'to_children', data: val || 'null'})
            }
        },

        to_dogs: {
            get() { return this.GET_BY_KEY('to_dogs') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'to_dogs', data: val || 'null'})
            }
        },

        to_cats: {
            get() { return this.GET_BY_KEY('to_cats') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'to_cats', data: val || 'null'})
            }
        },

        human_sociability: {
            get() { return this.GET_BY_KEY('human_sociability') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'human_sociability', data: val || 'null'})
            }
        },

        enrichment: {
            get() { return this.GET_BY_KEY('enrichment') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'enrichment', data: val || 'null'})
            }
        },



    },



    methods: {

        handleSocial({ target, rate }){
            this[target] = rate;
        },

        isValid() {
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true

        }
    },

    validations: {
        filters: {
            required: requiredIf( function () {
                return Array.isArray( this.filters ) && this.filters.length > 4
            } ),
            maxLength: maxLength(4)
        }
    }


}
</script>

<style scoped>

</style>
